import apiClient from './apiClient';
import { LANGUAGE_URL } from './apiUrl';

const getLanguageAllApi = () => {
  return apiClient.get(LANGUAGE_URL);
};

export { getLanguageAllApi };
